/* k4k-sticky-atc.js (polish pass, PREVIEW theme only). Phones and tablets up to 1,024px (Boardroom Step 3, 25 Oct 2026; was phones only): once the real Add to cart button has scrolled out of view,
   a slim bar shows the price and an Add to cart button. The bar's button just submits the page's own product form (same variant,
   quantity and subscription choice as the normal button), so no cart logic is changed. Delete this file and its <script> in layout/theme.liquid to remove. */
(function(){
  var mq=window.matchMedia('(max-width: 1024px)');
  function init(){
    var form=document.querySelector('product-form form[action*="/cart/add"]');
    var real=(form&&document.querySelector('button.k4k-atc-inline[form="'+form.id+'"]'))||(form&&form.querySelector('button[type="submit"][name="add"]'));
    if(!real||!window.IntersectionObserver)return;
    var title=document.querySelector('.product__title');
    var bar=document.createElement('div');
    bar.className='k4k-atc';bar.hidden=true;bar.setAttribute('role','region');bar.setAttribute('aria-label','Quick add to cart');
    bar.innerHTML='<div class="k4k-atc__info"><span class="k4k-atc__title"></span><span class="k4k-atc__price"></span></div><button type="button" class="k4k-atc__btn"></button>';
    document.body.appendChild(bar);
    var t=bar.querySelector('.k4k-atc__title'),p=bar.querySelector('.k4k-atc__price'),b=bar.querySelector('.k4k-atc__btn');
    function sync(){
      var th=title&&(title.querySelector('h1')||title);var h=th&&th.textContent.trim().replace(/\s+/g,' ');t.textContent=h||'';
      var pi=document.querySelector('.product__info-container .price-item--regular, .product__info-container .price-item--sale, .product__info-container .price-item');
      var inc=document.documentElement.getAttribute('data-k4k-vat')==='inc';
      var pe=pi&&(pi.querySelector(inc?'.k4k-inc':'.k4k-ex')||pi);
      p.textContent=pe?pe.textContent.trim().replace(/\s+/g,' ')+(inc?' inc VAT':' ex VAT'):'';
      var label=real.querySelector('span');b.textContent=(label?label.textContent:real.textContent).trim().replace(/\s+/g,' ')||'Add to cart';
      b.disabled=real.disabled||real.getAttribute('aria-disabled')==='true';
    }
    b.addEventListener('click',function(){
      if(b.disabled)return;
      if(form.requestSubmit)form.requestSubmit(real);else real.click();
    });
    var visible=true,root=document.documentElement;
    function apply(){
      var on=mq.matches&&!visible&&!root.classList.contains('k4k-cookie-open');
      if(on)sync();
      bar.hidden=!on;root.classList.toggle('k4k-atc-on',on);
      root.style.setProperty('--k4k-atc-h',on?bar.offsetHeight+'px':'0px');
    }
    new IntersectionObserver(function(e){visible=e[0].isIntersecting;apply()},{threshold:0}).observe(real);
    mq.addEventListener?mq.addEventListener('change',apply):mq.addListener(apply);
    new MutationObserver(apply).observe(root,{attributes:true,attributeFilter:['class']});
    document.addEventListener('k4k-vat-change',function(){if(!bar.hidden)sync()});
    new MutationObserver(function(){if(!bar.hidden)sync()}).observe(real,{attributes:true,childList:true,subtree:true});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
